"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pDataB = exports.pDataI = exports.pData = void 0;
var Term_1 = require("../../../Term/index.js");
var types_1 = require("../../../type_system/types.js");
var plutus_data_1 = require("@harmoniclabs/plutus-data");
var IRConst_1 = require("../../../../IR/IRNodes/IRConst.js");
function pData(dataElem) {
    return new Term_1.Term(types_1.data, function (_dbn) { return IRConst_1.IRConst.data(dataElem); }, true // isConstant
    );
}
exports.pData = pData;
function pDataI(n) {
    return new Term_1.Term((0, types_1.asData)(types_1.int), function (_dbn) { return IRConst_1.IRConst.data(new plutus_data_1.DataI(n)); }, true // isConstant
    );
}
exports.pDataI = pDataI;
function pDataB(b) {
    return new Term_1.Term((0, types_1.asData)(types_1.bs), function (_dbn) { return IRConst_1.IRConst.data(new plutus_data_1.DataB(b)); }, true // isConstant
    );
}
exports.pDataB = pDataB;
